import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  Timeline,
  TimelineItem,
  TimelineTitle,
  TimelineCompany,
  TimelinePeriod,
  TimelineDescription,
  SkillTags,
  SkillTag,
} from '../styles';

interface ExperienceProps {
  themeName: ThemeType;
}

interface JobData {
  title: string;
  company: string;
  period: string;
  description: string;
  tags: string[];
}

const Experience: React.FC<ExperienceProps> = ({ themeName }) => {
  const { t } = useTranslation();
  const jobs = t('ClassicPage.experience.jobs', { returnObjects: true }) as JobData[];

  if (!Array.isArray(jobs)) return null;

  return (
    <SectionWrapper id="experience" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ git log --oneline career</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('ClassicPage.experience.title')}</SectionTitle>
      <Timeline $themeName={themeName}>
        {jobs.map((job, i) => (
          <TimelineItem key={i} $themeName={themeName}>
            <TimelineTitle $themeName={themeName}>{job.title}</TimelineTitle>
            <TimelineCompany $themeName={themeName}> — {job.company}</TimelineCompany>
            <TimelinePeriod $themeName={themeName}>{job.period}</TimelinePeriod>
            <TimelineDescription $themeName={themeName}>{job.description}</TimelineDescription>
            <SkillTags>
              {job.tags.map((tag, j) => (
                <SkillTag key={j} $themeName={themeName}>{tag}</SkillTag>
              ))}
            </SkillTags>
          </TimelineItem>
        ))}
      </Timeline>
    </SectionWrapper>
  );
};

export default Experience;
